import { createContext, useContext, useEffect, useRef, useState } from "react";

const GearwiseCatalogContext = createContext();

const GearwiseCatalogProvider = ({ children }) => {
  const [selectedGearObj, setSelectedGearObj] = useState(null);
  const [branding, setBranding] = useState("Wh_B");
  const [carList, setCarList] = useState([]);
  const countRef = useRef(0); // this is for car is not found or user has not serached any car so preview car icons
  console.log("selectedGearObj", selectedGearObj);
  useEffect(() => {
    console.log("Gearwise mounted");
    return () => console.log("Gearwise unmounted");
  }, []);

  return (
    <GearwiseCatalogContext.Provider
      value={{
        setSelectedGearObj,
        selectedGearObj,
        setBranding,
        branding,
        setCarList,
        carList,
        countRef,
      }}
    >
      {children}
    </GearwiseCatalogContext.Provider>
  );
};

export default GearwiseCatalogProvider;

export const useGearwiseCatalog = () => {
  const context = useContext(GearwiseCatalogContext);
  if (!context) {
    console.error(
      "useGearwiseCatalog must be used within a GearwiseCatalogProvider",
    );
  }

  return context;
};
